import { render } from "./kerongxianwei.vue?vue&type=template&id=9cc2427c&scoped=true"
import script from "./kerongxianwei.vue?vue&type=script&lang=js"
export * from "./kerongxianwei.vue?vue&type=script&lang=js"

import "./kerongxianwei.vue?vue&type=style&index=0&id=9cc2427c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Administrator\\work\\zhongsheng\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cc2427c"]])

export default __exports__